export default function SobreNosotros() {
  return (
    <div className="legal-page">
      <div className="container">
        <nav className="legal-nav">
          <a href="./" className="nav-logo" aria-label="DATAGIS inicio">
            <img src="logo_lr.jpg" alt="" className="nav-logo-img nav-logo-img--footer" aria-hidden="true" />
          </a>
        </nav>

        <article className="legal-content" style={{ maxWidth: 780 }}>
          <h1>Sobre nosotros</h1>

          <h2>Quiénes somos</h2>
          <p>
            Los datos, y en especial los datos geolocalizados, ofrecen una visión completa
            de todo lo que nos rodea: la distribución de clientes y zonas de facturación,
            el estado del territorio y el medio ambiente, la gestión de infraestructuras,
            los riesgos operacionales o el comportamiento de cualquier variable con
            componente espacial. Tener esa información estructurada y visible no es un
            lujo; es una ventaja competitiva real.
          </p>
          <p>
            Cuando los datos se visualizan y se explotan correctamente, las organizaciones
            pueden optimizar sus procesos, reducir costes, anticiparse a problemas y tomar
            decisiones más rápidas y fundamentadas. El resultado es una mayor eficiencia,
            más productividad, una posición más competitiva en el mercado y, en definitiva,
            más valor añadido y mejores resultados para el negocio.
          </p>
          <p>
            En <strong>DATAGIS</strong> somos especialistas en hacer exactamente eso. Cubrimos
            todo el ciclo de la información geoespacial: desde la captura de datos en campo
            con drone, GPS RTK o escáner LiDAR, hasta su análisis, visualización y entrega
            a través de nuestra plataforma web segura, accesible 24/7. Cada proyecto se
            diseña a medida, con adaptabilidad, eficacia y calidad técnica como señas de
            identidad.
          </p>

          <h2>Nuestros servicios</h2>
          <ul>
            <li>
              <strong>Vuelos con drone:</strong> vuelos profesionales operados por pilotos
              certificados con seguro de responsabilidad civil en vigor. Fotografías de alta
              resolución, vídeos 4K, tours virtuales 360º, ortofotos georreferenciadas con
              precisión de 1 cm/px y modelos 3D texturizados.
            </li>
            <li>
              <strong>Dashboards interactivos:</strong> dashboards operacionales y analíticos,
              rápidos y totalmente personalizables, disponibles en entorno web seguro 24/7
              con acceso por usuario y contraseña. Adaptados al sector empresarial o público.
            </li>
            <li>
              <strong>GIS:</strong> estudios detallados con tecnología GIS para análisis
              territoriales precisos: GIS ambiental, agronómico, de emergencias y gestión
              de riesgos, y análisis territorial personalizado.
            </li>
            <li>
              <strong>Planes de Autoprotección:</strong> redacción e implantación conforme al
              Decret 30/2015 de la Generalitat de Catalunya y al RD 393/2007. Incluye formación
              del personal, simulacros y revisiones periódicas.
            </li>
            <li>
              <strong>Levantamientos topográficos GPS:</strong> levantamientos con GPS RTK de
              precisión centimétrica para estudios catastrales, urbanismo, ingeniería y
              gestión territorial. Perfiles longitudinales, transversales y planimetría detallada.
            </li>
            <li>
              <strong>Modelado 3D con LiDAR:</strong> escaneado interior y exterior de edificios,
              locales, naves industriales y comercios. Nube de puntos de alta densidad y modelos
              3D texturizados listos para BIM.
            </li>
            <li>
              <strong>Apps móviles y plataformas de gestión:</strong> desarrollo de aplicaciones
              móviles con plataforma web para gestión de incidencias urbanas, inventarios de
              elementos geolocalizados y cualquier necesidad a medida. Acceso por roles: operario
              de campo, técnico y gestor.
            </li>
            <li>
              <strong>Proyectos GIS en la nube:</strong> publicación y gestión de proyectos GIS
              accesibles desde cualquier dispositivo sin instalar software. Visualizadores
              interactivos, integración con WMS/WFS y compartición segura con clientes.
            </li>
            <li>
              <strong>Desarrollo web:</strong> diseño y desarrollo de páginas web profesionales
              con puntuaciones 90–100 en Google PageSpeed. SEO técnico optimizado, diseño
              adaptado a tu marca y accesible para todos los dispositivos.
            </li>
          </ul>

          <h2>¿Por qué elegirnos?</h2>
          <ul>
            <li>
              <strong>Calidad a precio asequible:</strong> tecnología de primer nivel con
              una relación calidad-precio difícil de superar en el mercado.
            </li>
            <li>
              <strong>Eficacia y rapidez:</strong> proyectos entregados en el plazo acordado
              y con los resultados comprometidos, sin demoras ni sorpresas.
            </li>
            <li>
              <strong>Adaptabilidad total:</strong> cada solución se diseña a medida de las
              necesidades específicas de tu empresa o sector.
            </li>
          </ul>

          <h2>Plataforma DATAGIS</h2>
          <p>
            Todos los resultados se entregan de forma segura y personalizada a través de nuestra
            plataforma web, accesible mediante usuario y contraseña las 24 horas del día.
            La plataforma permite explorar proyectos de muestra antes de contratar y gestionar
            los proyectos en curso de forma centralizada.
          </p>

          <h2>Contacto</h2>
          <p>
            Si quieres saber más sobre nuestros servicios o explorar cómo DATAGIS puede ayudar
            a tu empresa o municipio, escríbenos a{' '}
            <a href="mailto:info@datagis.es">info@datagis.es</a>, llámanos al{' '}
            <a href="tel:+34611336521">+34 611 33 65 21</a> o{' '}
            <a href="./#contacto">contacta desde la web</a>.
          </p>
          <p>
            Horario de atención: lunes a viernes de 09:00 a 18:00.
          </p>
        </article>

        <footer className="legal-footer">
          <a href="./" className="btn btn-ghost btn-sm">← Volver al inicio</a>
          <span>© 2026 DATAGIS</span>
        </footer>
      </div>
    </div>
  );
}
